import {format} from 'date-fns'

const emptyEcafResponse = {
  ausNzResStudy: null,
  austPartStudy: null,
  austResStudy: null,
  campus: '',
  citizenship: '',
  cnfrmdHelpEligibleNZInd: '',
  courseCd: '',
  courseName: '',
  dob: '',
  firstName: '',
  formName: '',
  fullUpFrontPayment: '',
  gender: '',
  ineligibleForSAHelpInd: '',
  institution: '',
  lastName: '',
  lastUpdate: {
    date: '',
  },
  nhResAustStudy: null,
  nZVisaCriteria: null,
  nZVisaIndicator: null,
  studentId: '',
  taxFileCertificate: '',
  taxFileNumberExists: '',
}

const calculateTaxFileCertificateEligibility = ecafDetails => {
  if (ecafDetails.taxFileNumberExists === 'Y') {
    return 'N'
  }
  return ecafDetails.taxFileCertificate
}

export default (
  state = {
    isFetching: true,
    originalData: emptyEcafResponse,
    updatedData: emptyEcafResponse,
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_ECAF_DETAILS':
      return {
        ...state,
        isFetching: true,
        originalData: emptyEcafResponse,
        updatedData: emptyEcafResponse,
      }
    case 'RECEIVE_ECAF_DETAILS':
      const ecafDetails = {
        ...action.ecafDetails,
        taxFileCertificate: calculateTaxFileCertificateEligibility(action.ecafDetails),
      }

      return {
        ...state,
        isFetching: false,
        originalData: ecafDetails,
        updatedData: ecafDetails,
      }
    case 'RECEIVE_ECAF_DETAILS_FAILED':
      return {
        ...state,
        isFetching: false,
        originalData: emptyEcafResponse,
        updatedData: emptyEcafResponse,
      }
    case 'UPDATE_AUST_PART_STUDY':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          austPartStudy: action.austPartStudy,
        }
      }
    case 'UPDATE_ECAF_FULL_UPFRONT_PAYMENT':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          fullUpFrontPayment: action.fullUpFrontPayment,
        }
      }
    case 'UPDATE_NZ_VISA_CATEGORY':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          nZVisaCriteria: action.nZVisaCriteria,
        }
      }
    case 'UPDATE_NZ_VISA_INDICATOR':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          nZVisaIndicator: action.nZVisaIndicator,
        }
      }
    case 'UPDATE_NZ_RES_STUDY':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          ausNzResStudy: action.ausNzResStudy,
        }
      }
    case 'UPDATE_NH_RES_STUDY':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          nhResAustStudy: action.nhResAustStudy,
        }
      }
    case 'UPDATE_AUST_RES_STUDY':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          austResStudy: action.austResStudy,
        }
      }
    case 'SAVE_HECS_HELP_FORM':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          ...action.updatedFields,
          lastUpdate: {
            ...state.updatedData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          },
        }
      }
    case 'SAVE_FEE_HELP_FORM':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          ...action.updatedFields,
          lastUpdate: {
            ...state.updatedData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          },
        }
      }
    case 'SAVE_CSP_HELP_FORM':
      return {
        ...state,
        updatedData: {
          ...state.updatedData,
          ...action.updatedFields,
          lastUpdate: {
            ...state.updatedData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          },
        }
      }
    case 'SUBMIT_ECAF_DETAILS':
      const updatedEcafDetails = {
        ...action.updatedEcafDetails,
        taxFileCertificate: calculateTaxFileCertificateEligibility(action.updatedEcafDetails),
      }

      return {
        ...state,
        originalData: updatedEcafDetails,
        updatedData: updatedEcafDetails,
      }
    case 'SUBMIT_ECAF_DETAILS_ALREADY_SUBMITTED':
      return {
        ...state,
        originalData: {
          ...state.originalData,
          lastUpdate: {
            ...state.originalData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          }
        },
        updatedData: {
          ...state.updatedData,
          lastUpdate: {
            ...state.updatedData.lastUpdate,
            date: format(new Date(), 'YYYY-MM-DD'),
          }
        },
      }
    default:
      return state
  }
}
